
<div class="flex align-center justify-center">
  
  <div class="builder-container">
    <app-quote-builder-strategy></app-quote-builder-strategy>
  </div>
</div>